'use strict';

define('lib/helpers/data',['Handlebars'], function(Handlebars) {
  Handlebars.registerHelper('data', function (hash) {
    var attr = [];
    for (var k in hash) {
      if(k.indexOf('data-') === 0) {
        attr.push(k + '="' + Handlebars.Utils.escapeExpression(hash[k]) + '"');
      }
    }
    return new Handlebars.SafeString(attr.join(' '));
  });
})
;
